// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__1UnFu","wrapper":"style_wrapper__E7YG-","parentContainer":"style_parentContainer__8gHSB","uploadDiv":"style_uploadDiv__29VRr"};